/* eslint-disable @stylistic/indent */
const hiraToKata = (str) => {
    return str.replace(/[\u3041-\u3096]/g, (match) => {
        const chr = match.charCodeAt(0) + 0x60
        return String.fromCharCode(chr)
    })
}

const isPointPartiallyMatched = (point, keyword) => {
    const pointJaMatched = new RegExp(keyword, 'i').test(hiraToKata(point.city_kanji))
    const pointKanaMatched = new RegExp(keyword, 'i').test(hiraToKata(point.city_kana))
    return pointJaMatched || pointKanaMatched
}

const isPointFullyMatched = (point, keyword) => {
    const pointJaFullMatched = new RegExp(`^${keyword}$`, 'i').test(hiraToKata(point.city_kanji))
    const pointKanaFullMatched = new RegExp(`^${keyword}$`, 'i').test(hiraToKata(point.city_kana))
    return pointJaFullMatched || pointKanaFullMatched
}

export const useWordSearch = (searchPointList) => {
    const result = ref([])
    const keyword = ref('')

    const search = () => {
        if (keyword.value === '') {
            result.value = []
            return
        }

        const normalizedKeyword = hiraToKata(keyword.value).replace(/\u3000/g, ' ')

        result.value = searchPointList
            .map((point) => {
                let score = 0
                if (isPointPartiallyMatched(point, normalizedKeyword)) score += 2
                if (isPointFullyMatched(point, normalizedKeyword)) score += 1
                return { ...point, score }
            })
            .filter((point) => point.score > 0)
            .sort((a, b) => b.score - a.score)
    }

    watch(keyword, search, { immediate: true })

    return {
        result,
        keyword
    }
}
